import { observable, action, runInAction } from "mobx";
import { Insumo, Grupo } from "../../../../services";
import { error, success } from "../../../../utils/MensagemUtil";
import { validarCamposObrigatorios } from "../../../../utils/Validate";
import * as util from "../../../../utils/MascaraUtil";
import * as CsTipoUnidade from "../../../../constantes/CsTipoUnidade";

class InsumoStore {
  @observable
  insumo = {
    id: null,
    nome: "",
    grupoId: "",
    grupo: "",
    descricao: "",
    valor: "",
    unidade: "",
    percentual: 21,
    valorTotal: 0.0
  };

  @observable
  insumos = [];

  @observable
  grupos = [];

  @observable
  criterio = {
    nome: "",
    grupo: ""
  };

  @observable
  unidades = CsTipoUnidade.values;

  @observable
  paginacao = {};

  @observable
  fetching = false;

  @action.bound
  async filtrar() {
    try {
      this.fetching = true;

      const result = await Insumo.consultar(this.criterio);
      if (result && result.erro) {
        return error(result.erro);
      }

      this.insumos = result.data.map(s => ({
        ...s,
        unidade: CsTipoUnidade.valueOf(s.unidade).simbolo
      }));

      this.paginacao = result.paging;
    } finally {
      this.fetching = false;
    }
  }

  @action.bound
  async remover(id) {
    try {
      this.fetching = true;

      const result = await Insumo.excluir(id);
      if (result.erro) {
        error(result.erro);
        return;
      }

      success("Insumo excluído com sucesso.");

      this.filtarr();
    } finally {
      this.fetching = false;
    }
  }

  @action.bound
  paginar = target => {
    this.criterio = {
      ...this.criterio,
      pagina: target.page,
      limite: target.limit
    };
    this.filtrar();
  };

  @action.bound
  handleChange = ({ target }) => {
    const { name, value } = target;

    this.insumo[name] = value;
  };

  @action.bound
  handleChangeFiltro = ({ target }) => {
    const { name, value } = target;

    this.criterio[name] = value;
  };

  @action.bound
  async carregarGrupos() {
    try {
      this.fetching = true;

      const result = await Grupo.consultar({ limite: 50 });
      if (result && result.erro) {
        this.grupos = [];
        error(result.erro);
        return;
      }

      this.grupos = result.data.map(grupo => ({
        label: grupo.nome,
        value: grupo.id
      }));
    } finally {
      this.fetching = false;
    }
  }

  definirGrupo = target => {
    runInAction(() => {
      this.insumo.grupoId = target ? target.value : null;
      this.insumo.grupo = target;
    });
  };

  @action.bound
  async alterar(history) {
    try {
      this.fetching = true;

      const erros = this.validarCadastro(this.insumo);
      if (erros.length > 0) {
        error(erros);
        return;
      }

      const result = await Insumo.alterar(this.toInsumo());
      if (result.erro) {
        error(result.erro);
        return;
      }

      success("Insumo alterado com sucesso.");
      history.push("/cadastros/insumos");
    } finally {
      this.fetching = false;
    }
  }

  @action.bound
  async buscar(id) {
    try {
      this.fetching = true;

      const result = await Insumo.buscar(id);
      if (result && result.erro) {
        this.insumo = {};
        error(result.erro);
        return;
      }

      this.insumo = {
        ...result,
        id: parseInt(result.id, 0),
        valor: util.moeda(result.valor),
        unidade: parseInt(result.unidade, 0),
        percentual: parseFloat(result.percentual, 0),
        grupo: {
          label: result.grupo,
          value: result.grupoId
        }
      };

      this.calcularTotal();
    } finally {
      this.fetching = false;
    }
  }

  @action.bound
  async cadastrar(history) {
    try {
      this.fetching = true;

      const erros = this.validarCadastro(this.insumo);
      if (erros.length > 0) {
        error(erros);
        return;
      }

      const result = await Insumo.cadastrar(this.toInsumo());
      if (result.erro) {
        error(result.erro);
        return;
      }

      success("Insumo cadastrado com sucesso.");
      history.push("/cadastros/insumos");
    } finally {
      this.fetching = false;
    }
  }

  validarCadastro = registro => {
    const erros = validarCamposObrigatorios()
      .addSeNuloOuVazio("Grupo", registro.grupoId)
      .addSeNuloOuVazio("Nome", registro.nome)
      .addSeNuloOuVazio("Valor R$", registro.valor)
      .addSeNuloOuVazio("Unidade", registro.unidade)
      .build();

    return erros;
  };

  @action.bound
  calcularTotal = () => {
    const valor = util.remover(this.insumo.valor);
    const total = parseFloat(valor - (valor * parseFloat(this.insumo.percentual, 0)) / 100, 0);

    this.insumo.valorTotal = util.moeda(total);
  };

  toInsumo() {
    const novo = {
      id: this.insumo.id,
      nome: this.insumo.nome,
      descricao: this.insumo.descricao,
      grupoId: parseInt(this.insumo.grupoId, 0),
      valor: util.remover(this.insumo.valor),
      unidade: parseInt(this.insumo.unidade, 0),
      percentual: parseFloat(this.insumo.percentual, 0)
    };

    return novo;
  }
}

export default new InsumoStore();



// WEBPACK FOOTER //
// ./src/views/cadastros/insumos/stores/InsumoStore.js